import { InputProps, SearchProps, PasswordProps } from "antd/lib/input";
import { ReactElement } from "react";

interface commonProps {
	addOnAfter?: string | ReactElement;
	addOnBefore?: string | ReactElement;
	zref?:
		| React.RefObject<HTMLInputElement>
		| ((instance: HTMLInputElement | null) => void)
		| null;
	inputType?: "normal" | "password" | "search" | "copy-contents";
	copyText?: string;
	width?: number | string;
	showCount?: boolean;
	showCountAlign?: "right" | "left" | "center";
	isAutoCompleteOff?: boolean;
}

export interface IInputProps extends InputProps, commonProps {}
export interface ISearchProps extends SearchProps, commonProps {}
export interface IPasswordProps extends PasswordProps, commonProps {}

export enum EInputWidths {
	sm = "sm",
	md = "md",
	lg = "lg",
	xl = "xl",
	full = "full"
}
